import StorageService from '@/services/storage.service'
import storageKeys from '@/constants/storageKeys'
import { defaultFilters } from '@/models/GeneratedLinks/helpers'
import TableOptions from '@/models/TableOptions'
import { omitEmptyDeepFilters, prepareFilters } from '@/helpers/filters'
import generatedLinksRepository from '@/repository/generatedRepository/generatedLinksRepository'

const state = {
  list: [],
  filters: StorageService.get(storageKeys.GENERATED_LINKS_FILTERS) || { ...defaultFilters() },
  tableOptions: TableOptions.defaultTableOptions(),
}

const getters = {
  filters: state => state.filters,
  tableOptions: state => state.tableOptions,
  list: state => state.list,
  isOpenFilterPanel: state =>
    state.filters.clientOptions && state.filters.clientOptions.filterPanelExpanded,
}

const actions = {
  async loadData(context, filters) {
    context.commit('setFilters', filters)
    StorageService.set(storageKeys.GENERATED_LINKS_FILTERS, filters)

    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const appliedCfFilters = omitEmptyDeepFilters(filters.cfFilter)

    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
      cfFilter: appliedCfFilters,
    })

    const { data } = await generatedLinksRepository.list(preparedFilters)

    context.commit('setList', { data, filters })

    return { products: data.items, pagination: data.pagination }
  },
  async searchGeneratedLinks(context, filters) {
    const appliedFilters = omitEmptyDeepFilters(filters.filter)
    const preparedFilters = prepareFilters({
      ...filters,
      filter: appliedFilters,
    })

    const { data } = await generatedLinksRepository.list(preparedFilters)

    return { products: data.items, pagination: data.pagination }
  },
  async loadItem(context, id) {
    const { data } = await generatedLinksRepository.get(id)
    if (Array.isArray(data.offerPartners)) {
      data.offerPartners = data.offerPartners
        .slice()
        .sort((a, b) => (a.offer?.title || '').localeCompare(b.offer?.title || '', undefined, { numeric: true }))
    }
    data.existedLinks =
      Number.isFinite(data.totalLinks) && Number.isFinite(data.newLinks)
        ? data.totalLinks - data.newLinks
        : 0
    return data
  },
  createItem(context, payload) {
    return generatedLinksRepository.post(payload)
  },
  updateItem(context, payload) {
    const { id, ...data } = payload
    return generatedLinksRepository.put(id, data)
  },
  deleteItem(context, payload) {
    return generatedLinksRepository.delete(payload)
  },
  filtersStorageReset() {
    StorageService.remove(storageKeys.GENERATED_LINKS_FILTERS)
  },
  updateFiltersClientOptions({ commit, getters }, clientOptions) {
    const updatedFilters = {
      ...getters.filters,
      clientOptions,
    }
    commit('setFilters', updatedFilters)
    StorageService.set(storageKeys.GENERATED_LINKS_FILTERS, updatedFilters)
  },
}

const mutations = {
  setList(state, { data, filters }) {
    state.list = [...data.items]
    state.tableOptions = new TableOptions(data.pagination, filters)
  },
  setFilters(state, filters) {
    state.filters = { ...filters }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
